import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { installGlobalErrorHandlers } from './telemetry';
import './styles/tokens.css';
import './styles/global.css';

installGlobalErrorHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
